import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../shared/Sidebar";

function Building() {
  const baseUrl = process.env.baseUrl;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    cooled: "",
    envelopeSpecs: "",
    roofInsulation: "",
    coolRoof: "",
    windowFilms: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.cooled.trim()) newErrors.cooled = "This field is required";
    if (!formData.envelopeSpecs.trim()) newErrors.envelopeSpecs = "This field is required";
    if (!formData.roofInsulation.trim()) newErrors.roofInsulation = "This field is required";
    if (!formData.coolRoof.trim()) newErrors.coolRoof = "This field is required";
    if (!formData.windowFilms.trim()) newErrors.windowFilms = "This field is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.post("/api/building", formData); // Replace with actual endpoint
      navigate("/equipment");
    } catch (err) {
      console.error("Error submitting form", err);
      alert("Submission failed. Please try again.");
    }
  };

  return (
    <div className="container col-lg-9 mt-5">
      <div className="row">
        <div className="col-md-4">
          <Sidebar />
        </div>

        <div className="col-md-8">
          <div className="form-section">
            <h5 className="mb-4">Building Envelope / Thermal Efficiency</h5>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="cooled"
                    className={`form-control ${errors.cooled ? "is-invalid" : ""}`}
                    placeholder="Is Production Building Cooled?"
                    value={formData.cooled}
                    onChange={handleChange}
                  />
                  {errors.cooled && <div className="invalid-feedback">{errors.cooled}</div>}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="envelopeSpecs"
                    className={`form-control ${errors.envelopeSpecs ? "is-invalid" : ""}`}
                    placeholder="Envelope Specs"
                    value={formData.envelopeSpecs}
                    onChange={handleChange}
                  />
                  {errors.envelopeSpecs && <div className="invalid-feedback">{errors.envelopeSpecs}</div>}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="roofInsulation"
                    className={`form-control ${errors.roofInsulation ? "is-invalid" : ""}`}
                    placeholder="PU/Steel Roof with Insulation"
                    value={formData.roofInsulation}
                    onChange={handleChange}
                  />
                  {errors.roofInsulation && <div className="invalid-feedback">{errors.roofInsulation}</div>}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="coolRoof"
                    className={`form-control ${errors.coolRoof ? "is-invalid" : ""}`}
                    placeholder="Cool Roof or Walls?"
                    value={formData.coolRoof}
                    onChange={handleChange}
                  />
                  {errors.coolRoof && <div className="invalid-feedback">{errors.coolRoof}</div>}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="windowFilms"
                    className={`form-control ${errors.windowFilms ? "is-invalid" : ""}`}
                    placeholder="Window Films (Sky lights >300 m²)"
                    value={formData.windowFilms}
                    onChange={handleChange}
                  />
                  {errors.windowFilms && <div className="invalid-feedback">{errors.windowFilms}</div>}
                </div>
              </div>

              <button type="submit" className="btn btn-custom w-100">
                Continue →
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Building;
